import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs';
import { ApiService } from 'src/app/_services/api.service';

@Component({
    selector: 'app-declineinvalue',
    templateUrl: './declineinvalue.component.html',
    styleUrls: ['./declineinvalue.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeclineinvalueComponent implements OnInit, AfterViewInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  pageId: string;
  pageName = "Decline In Value/ Property Tax Relief";
  id = 0;
  open=true;
  tab='General Info'
  enable = true;
  randomBool = true;
  FaqData: any;
  FormData: any;
  date = new Date().getFullYear();
  name_browser = '';
  isChrome = false;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
    this.id = tabId + 1;
  }

  constructor(private actRoute: ActivatedRoute,  private apiService: ApiService,) {
    this.id = this.actRoute.snapshot.params.id || null;
  }

  onSelect(data: TabDirective): void {
    this.tab = data.heading();
    // console.log('tab ' + this.tab);
    if(!this.pageId) {

      this.apiService.getPage(this.pageName).subscribe(data => {
        this.pageId = data.id.toString();
        if(this.tab.toLowerCase() === 'faq') {
          this.getFaq();
        }
        else if(this.tab.toLowerCase() == 'forms') {
          this.getForm();
        }

      })
    }
    else {
      if(this.tab.toLowerCase() === 'faq') {
        this.getFaq();
      }
      else if(this.tab.toLowerCase() == 'forms') {
        this.getForm();
      }

    }

  }
  getFaq() {
    // console.log(this.pageName)
    this.apiService.getFaqByPage(this.pageId).subscribe(data => {
      this.FaqData = data;
      // console.log(data);
    })

  }

  getForm() {
    this.apiService.getFormByPage(this.pageId).subscribe(data => {
      this.FormData = data;

    })
  }
  //Find browser name
  findname_browser() {
    const agent = window.navigator.userAgent.toLowerCase()
    // console.log(agent);
    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(window as any).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  isChromeBrowser(){
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edg') > -1:
        return false;
      case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
        return true;

      default:
        return false;
    }
  }

  ngAfterViewInit() {
    if(this.id !== null)
      this.selectTab(this.id - 1);
  }

  ngOnInit() {
    //this.name_browser = this.findname_browser();
    this.isChrome = this.isChromeBrowser();
  }
}
